export const SLPLQTypes = {
    next: 'بعدی',
    linkEmp: 'لطفا لینک را وارد نمایید',
    linkErr: 'لینک وارد شده معتبر نیست',
    scoreErr: 'لطفا امتیاز را وارد کنید',
    selectiveErr: 'لطفا یک گزینه را انتخاب کنید',
    multiSelectEmp: 'لطفا حداقل ک گزینه را انتخاب کنید',
    phoneEmp: 'لطفا شماره را وارد کنید',
    phoneErr: 'شماره وارد شده معتبر نیست',
    emailEmp: 'لطفا ایمیل را وارد کنید',
    emailErr: 'ایمیل وارد شده معتبر نیست',
    dateEmp: 'لطفا تاریخ را وارد کنید',
    textEmp: 'وارد کردن این بخش الزامی ست',
    textErr: 'عبارت وارد شده معتبر نیست',
    numEmp: 'وارد کردن این عدد الزامی ست',
    numErr: 'عدد وارد شده معتبر نیست',
    emojiEmp: 'لطفا ایموجی مورد نظرتان را وارد کنید',
    fileEmp: 'لطفا فایل مورد نظر را وارد کنید',
    cameraEmp: 'لطفا عکس را بارگذاری نمایید',
    priEmp: 'لطفا اولویت های خود را مشخص کنید',
    matrixEmp: 'لطفا حداقل یک مورد را وارد کنید',
    voiceEmp: 'لطفا صدا را ضبط و بارگزاری کنید',
};
